<template>
  <v-row no-gutters v-if="$store.state.auth.account.id && $route.meta.displayNavigationDrawer" style="z-index: 0">
    <v-navigation-drawer class="px-3" v-model="drawer" v-if="$route.meta.displayDrawer" app clipped elevation="1" width="200px" hide-overlay stateless fixed style="margin-left: 60px;">
      <!-- options list -->
      <v-list dense nav class="v-list-drawer">
        <v-subheader class="mt-3 px-0 subtitle-1 font-weight-medium">{{selectedIcon === 'AccountBasic' ? 'Configuración' : selectedOption.title}}</v-subheader>
        <v-list-item-group>
          <template v-for="option in selectedOption.options">
            <v-list-item :key="`${option.link}-main`" color="primary" :ripple="false" :to="(option.title !== 'Dashboard' ? { name: `${option.link}` } : '')">
              <v-list-item-content class="py-0">
                <v-list-item-title class="text-none subtitle-2 font-weight-medium" v-if="option.title !== 'Colección de Métricas' && option.title !== 'Dashboard'">{{ option.title }}</v-list-item-title>
                <dashboard-drop-down v-if="option.title === 'Dashboard'" />
                <metrics-drop-down v-if="option.title === 'Colección de Métricas'" />
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="pl-6 nl-2" v-for="o in option.options" exact :key="`${o.link}-option`" :ripple="false" :to="{ name: o.link }">
              <v-list-item-title class="body-2">{{o.title}}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <div class="v-navigation-drawer__handler left" @click="drawer=!drawer" v-if="drawer && $route.meta.displayDrawer"></div>
    </v-navigation-drawer>

    <!-- icons -->
    <v-navigation-drawer app clipped fixed mobile-breakpoint mini-variant mini-variant-width="60" class="white" style="overflow: visible !important">
      <v-list>
        <v-list-item @click="goTo(link.link)" :to="link.link !== 'DashboardUpdate' ? { name: `${link.link}` } : newRoute" v-for="link in items.slice(0,8)" :key="link.title" @click.stop="drawer = !['AccountDashboard', 'Integrations'].includes(selectedIcon)">
          <v-tooltip right transition="scale-transition">
            <template v-slot:activator="{on}">
              <v-col v-on="on">
                <img :src="selectedIcon === link.link ? require(`@/assets/appIcon-menu--${link.icon}--active.svg`) : require(`@/assets/appIcon-menu--${link.icon}.svg`)" width="34">
              </v-col>
            </template>
            <span class="font-weight-medium">{{link.title}}</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
      <div class="v-navigation-drawer__handler right" @click="drawer = !['AccountDashboard', 'Integrations'].includes(selectedIcon)" v-if="!drawer && $route.meta.displayDrawer"></div>

      <!-- icon business -->
      <template v-slot:append>
        <v-list dense>
          <v-list-item :to="{ name: `${items[8].link}` }" class="mb-4" @click.stop="drawer = !['AccountDashboard', 'Integrations'].includes(selectedIcon)">
            <v-tooltip right transition="scale-transition">
              <template v-slot:activator="{on}">
                <v-col cols="12" justify="center" v-on="on">
                  <img :src="selectedIcon === items[8].link ? require('@/assets/appIcon-menu--Settings--active.svg') : require('@/assets/appIcon-menu--Settings.svg')" width="34">
                </v-col>
              </template>
              <span class="font-weight-medium">Configuración de la organización</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <!-- end icons -->
  </v-row>
</template>
<script>
import MetricsDropDown from '@/components/menu/MetricsDropDown'
import DashboardDropDown from '@/components/menu/DashboardDropDown'

export default {
  components: {
    MetricsDropDown,
    DashboardDropDown
  },
  data: () => ({
    drawer: false,
    newRoute: '',
    selectedIcon: 'AccountDashboard',
    currentOption: {
      title: 'Dashboard',
      icon: 'AccountDashboard',
      link: 'AccountDashboard'
    },
    items: [
      {
        title: 'Dashboard',
        icon: 'AccountDashboard',
        link: 'AccountDashboard'
      },
      {
        title: 'Suscripciones',
        icon: 'Subscriptions',
        link: 'SubscriptionList',
        options: [
          {
            title: 'Facturas recurrentes',
            link: 'SubscriptionList'
          },
          {
            title: 'Productos',
            link: 'ProductListCreate'
          },
          {
            title: 'Complementos',
            link: 'AddonListCreate'
          },
          {
            title: 'Cupones de descuento',
            link: 'CouponListCreate'
          },
          {
            title: 'Registros de uso',
            link: 'UsageListCreate'
          }
        ]
      },
      {
        title: 'Facturación',
        icon: 'Invoicing',
        link: 'InvoiceList',
        options: [
          {
            title: 'Facturas',
            link: 'InvoiceList'
          },
          {
            title: 'Notas de crédito',
            link: 'CreditNoteList'
          },
          {
            title: 'Órdenes',
            link: 'OrderList'
          }
        ]
      },
      {
        title: 'Ingresos',
        icon: 'Revenue',
        link: 'PaymentListCreate',
        options: [
          {
            title: 'Pagos',
            link: 'PaymentListCreate'
          },
          {
            title: 'Transferencias',
            link: 'TransactionList'
          },
          {
            title: 'Cuentas por cobrar',
            link: 'Receivables'
          }
        ]
      },
      {
        title: 'Contactos',
        icon: 'Contacts',
        link: 'CustomerListCreate',
        options: [
          {
            title: 'Clientes',
            link: 'CustomerListCreate'
          },
          {
            title: 'Personas',
            link: 'ContactListCreate'
          }
        ]
      },
      {
        title: 'Componentes',
        icon: 'Components',
        link: 'Components'
      },
      {
        title: 'Reportes',
        icon: 'Reports',
        link: 'DashboardUpdate',
        options: [
          {
            title: 'Dashboard'
          },
          {
            title: 'Colección de Métricas',
            link: 'MetricList'
          }
          // {
          //   title: 'Explorador de dashboards',
          //   link: 'DefaultDashboardList'
          // },
          // {
          //   title: 'Favoritos',
          //   link: 'Favorites'
          // },
        ]
      },
      {
        title: 'Integraciones',
        icon: 'Integrations',
        link: 'Integrations',
        options: [
          {
            title: 'Documentos recibidos',
            description: '',
            link: 'PurchaseList'
          },
          {
            title: 'Facturas de compra',
            description: '',
            link: 'RetentionList',
            options: [
              {
                title: 'Lotes',
                description: '',
                link: 'RetentionBulkListCreate'
              }
            ]
          },
          {
            title: 'Proveedores',
            description: '',
            link: 'SupplierListCreate'
          }
        ]
      },
      {
        title: 'Cuenta',
        description: '',
        link: 'AccountBasic',
        options: [
          {
            title: 'Cuenta',
            description: '',
            link: 'AccountBasic'
          },
          {
            title: 'Branding',
            description: '',
            link: 'AccountSettingsBranding'
          },
          {
            title: 'Facturación',
            description: '',
            link: 'AccountSettingsInvoicing'
          },
          {
            title: 'Pagos',
            description: '',
            link: 'AccountSettingsPayments'
          },
          {
            title: 'Banco',
            description: '',
            link: 'AccountSettingsBank'
          },
          {
            title: 'Correos electrónicos',
            description: '',
            link: 'AccountSettingsEmail'
          },
          {
            title: 'Webhooks',
            description: '',
            link: 'AccountSettingsWebhooksListCreate'
          },
          {
            title: 'Equipo',
            description: '',
            link: 'AccountMembers'
          },
          {
            title: 'Importar',
            description: '',
            link: 'AccountImports'
          },
          {
            title: 'Exportar',
            description: '',
            link: 'AccountExports'
          },
          {
            title: 'Facturación de Piriod',
            description: '',
            link: 'AccountBilling'
          }
        ]
      }
    ]
  }),
  computed: {
    hiddenDrawer () {
      return this.$router.options.routes.filter(r => !r.meta.displayDrawer).map(r => r.name)
    },
    selectedOption () {
      return this.items.find(item => item.link === this.selectedIcon) || {}
    }
  },
  created () {
    if (this.$route.meta.displayNavigationDrawer) {
      this.drawer = false
    }
  },
  watch: {
    $route: {
      immediate: false,
      handler: function (val) {
        this.selectedIcon = val.meta.parent
        this.drawer = !this.hiddenDrawer.includes(val.name)
      }
    }
  },
  mounted: function () {
    this.selectedIcon = this.$route.meta.parent
    this.$nextTick(() => {
      this.drawer = !this.hiddenDrawer.includes(this.$route.name)
    })
  },
  methods: {
    isSelected (name) {
      return this.$route.matched.some(item => item.name === name)
    },
    goTo (link) {
      if (link === 'DashboardUpdate') {
        this.$store.dispatch('dashboards/LIST', {
          resource: 'metrics/dashboards'
        })
        .then((response) => {
          if (response.data.results.length) {
           this.newRoute = '/dashboard/' + response.data.results[0].id + '/edit'
            this.$router.push({
              name: 'DashboardUpdate',
              params: {
                id: response.data.results[0].id
              }
            })
            .catch(err => err)
          } else {
            this.newRoute = '/dashboards'
            this.$router.push('/dashboards').catch(err => err)
          }
        })
      }
    }
  }
}
</script>
<style>
.nl-2 {
  min-height: 28px !important;
}
</style>